<template>
  <b-container id="wh-entry-monitor" fluid>
    <b-row>
      <b-col class="align-self-center py-1">
        <h5 v-translate="{countdown}">WH Entry Monitor <small>(Autorefresh in %{countdown}s)</small></h5>
      </b-col>
      <b-col class="align-self-center py-1">
        <div v-if="warehousesSelect.length > 0">
          <b-form-group class="mb-1">
            <b-form-select size="sm" v-model="filterWarehouse" :options="countryOverride ? warehousesSelect : []">
              <template slot="first">
                <option :value="null" v-translate>None</option>
              </template>
            </b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <b-col class="align-self-center">
        <b-form-group class="mb-1">
          <b-form-select size="sm" v-model="countryOverride" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" @change="setNewCountry" v-if="isInternational">
            <template slot="first">
              <option :value="null" v-translate>Select Country</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-alert variant="warning" :show="connectionError">
      <span v-translate="{countdownConnectionError}">There are connection errors. Retrying in %{countdownConnectionError}s.</span>
    </b-alert>

    <b-alert variant="warning" class="my-3" show v-if="!countryOverride || !filterWarehouse || (countryOverride && warehousesSelect.length === 0)">
      <h4 class="my-0" v-translate>You need to set a Country and the Country must have warehouses set.</h4>
    </b-alert>
    <b-row>
      <b-col cols="12" v-for="(shipping, i) in shippings" :key="shipping.id + i" v-if="countryOverride && warehousesSelect.length > 0 && shippings.length > 0">
        <b-card class="mb-1 p-0" v-if="!shipping.readableDistanceToDestination || (shipping.distanceToDestination && shipping.distanceToDestination > 100)">
          <b-row class="p-0">
            <b-col cols="1">
              <b-row>
                <b-col v-if="shipping.readableDistanceToDestination">
                  <h6 class="mb-0">{{shipping.readableDistanceToDestination}}</h6>
                  <h6 class="mb-0"><strong>{{shipping.eta}}</strong></h6>
                </b-col>
                <b-col v-else>
                  <span class="text-danger">
                    <small v-translate>No tracking</small>
                  </span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="3">
              <small>#{{shipping.courier.id}}</small> <strong>{{shipping.courier.name}}</strong><br>
              {{shipping.courier.phone | phone('ar')}}
            </b-col>
            <b-col>
              <h6 class="m-0">
                #{{shipping.id | uuid}}<br>
                <small v-translate="{qty: shipping.pickedup_shippings.length}">%{qty} shippings</small>
              </h6>
            </b-col>
            <b-col cols="6">
              <div>
                <b-badge class="mr-1" variant="dark" v-for="(item, index) in shipping.sizes" :key="index">
                  {{index}}
                  <small>{{item}}</small>
                </b-badge>
                <b-badge class="mr-1" variant="secondary" v-for="(item, index) in shipping.routingZones" :key="index">
                  {{index}}
                  <small>{{item}}</small>
                </b-badge>
              </div>
              <div>
                <b-badge class="mr-1" variant="dark" v-for="(item, index) in shipping.companies" :key="index">
                  {{index}}
                  <small>{{item}}</small>
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mb-1 p-0 bg-success text-white" v-else-if="shipping.distanceToDestination && shipping.distanceToDestination <= 100">
          <b-row class="p-0">
            <b-col cols="1">
              <small><strong>{{shipping.eta}}</strong></small>
            </b-col>
            <b-col cols="3">
              <small><strong>{{shipping.courier.name}}</strong></small>
            </b-col>
            <b-col>
              <h6 class="m-0">
                <small v-translate="{qty: shipping.pickedup_shippings.length}">%{qty} shippings</small>
              </h6>
            </b-col>
            <b-col cols="6">
              <div>
                <b-badge class="mr-1" variant="dark" v-for="(item, index) in shipping.sizes" :key="index">
                  {{index}}
                  <small>{{item}}</small>
                </b-badge>
                <b-badge class="mr-1" variant="dark" v-for="(item, index) in shipping.companies" :key="index">
                  {{index}}
                  <small>{{item}}</small>
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'whEntryMonitor',
  data() {
    return {
      shippings: [],
      filterWarehouse: null,
      warehouses: [],
      window: window,
      countryOverride: null,
      averageSpeed: 35,
      timeout: null,
      intervalCountdown: null,
      countdown: 60,
      connectionError: false,
      intervalConnectionError: null,
      countdownConnectionError: 10
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val && this.countryOverride) {
        this.getShippings()
      } else {
        this.clearTimeout()
        this.shippings = []
      }
    },
    countryOverride(val) {
      if (val) {
        this.getShippings()
      } else {
        this.clearTimeout()
        this.shippings = []
      }
    }
  },
  created() {
    this.fetchWarehouses()
  },
  mounted() {
    this.countryOverride = this.$cookies.get('country') && !this.$cookies.get('bypassCountry') ? this.$cookies.get('country') : null
    this.warehouses = this.warehousesSelect
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.fetchShippingSizes()
      .then(() => {
        this.fetchShippingTypes()
          .then(() => {
            if (this.filterWarehouse) {
              this.getShippings()
            }
          })
      })
  },
  methods: {
    clearTimeout() {
      this.connectionError = false
      clearTimeout(this.timeout)
      clearInterval(this.intervalCountdown)
      clearInterval(this.intervalConnectionError)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
    },
    setIntervalCountdownConnectionError() {
      clearInterval(this.intervalConnectionError)
      this.countdownConnectionError = 10
      this.intervalConnectionError = setInterval(function () {
        this.countdownConnectionError = this.countdownConnectionError === 0 ? 0 : this.countdownConnectionError - 1
      }.bind(this), 1000)
    },
    async getShippings() {
      if (this.countryOverride && this.filterWarehouse) {
        this.clearTimeout()
        let params = {
          filter_groups: [
            {
              filters: [
                ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'pickup').id],
                ['status', 'eq', 'INTRANSIT'],
                // ['updated_at', 'bt', [startDate, endDate]],
                ['courier_id', 'eq', null, 'true']
              ]
            }
          ],
          sort: [
            {
              key: 'updated_at',
              direction: 'desc'
            }
          ],
          includes: ['company', 'courier.courier_available.tracking', 'pickedupShippings.company']
        }
        if (!this.$cookies.get('bypassCountry') || this.countryOverride) {
          params.filter_groups.push(
            {
              filters: [
                ['from_country_iso_code', 'eq', this.countryOverride]
              ]
            }
          )
        }

        if (this.filterWarehouse) {
          params.filter_groups.push(
            {
              filters: [
                ['to_place_id', 'eq', this.filterWarehouse]
              ]
            }
          )
        }
        return this.$http.get(this.$appConfig.api.baseUrl + 'shippings', {params: params})
          .then(response => {
            this.shippings = response.body.data.map(x => {
              x.sizes = this.setShippingSizes(x)
              x.companies = this.setShippingCompanies(x)
              x.routingZones = this.setShippingRoutingZones(x)
              try {
                x.distanceToDestination = this.setDistanceToDestination(x)
                x.readableDistanceToDestination = this.distance(x.distanceToDestination, true)
                const minutes = x.distanceToDestination / 1000 * 60 / this.averageSpeed
                x.eta = this.moment().startOf('day').add(minutes, 'minutes').format(minutes < 60 ? 'm' : 'hh:mm') + (minutes < 60 ? ' min' : ' hs')
              } catch (e) {
                x.distanceToDestination = 100000000
                x.readableDistanceToDestination = null
              }
              return x
            }).sort((a, b) => a.distanceToDestination - b.distanceToDestination)
            this.timeout = setTimeout(function () {
              this.getShippings()
            }.bind(this), 60000)
            this.setIntervalCountdown()
          }, () => {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            this.connectionError = true
            this.setIntervalCountdownConnectionError()
            this.timeout = setTimeout(function () {
              this.getShippings()
            }.bind(this), 10000)
          })
      }
    },
    setShippingSizes(shippings) {
      const sizes = shippings.pickedup_shippings.map(x => {
        return this.shippingSizes.find(y => y.id === x.size_id).name
      })

      return sizes.filter(Boolean).reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
    },
    setShippingCompanies(shippings) {
      const companies = shippings.pickedup_shippings.map(x => {
        return x.company.name
      }).filter(Boolean).reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
      return companies
    },
    setShippingRoutingZones(shippings) {
      const routingZones = shippings.pickedup_shippings.map(x => {
        return x.routing_zone ? x.routing_zone.code : null
      }).filter(Boolean).reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
      return routingZones
    },
    setDistanceToDestination(shipping) {
      return this.getDistance({lat: shipping.address_to.lat, lng: shipping.address_to.lng}, {lat: shipping.current_tracking.lat, lng: shipping.current_tracking.lng})
    },
    setNewCountry() {
      if (this.countryOverride !== null) {
        this.fetchWarehouses(this.countryOverride)
        this.filterWarehouse = null
        this.shippings = []
      } else {
        this.warehouses = []
        this.filterWarehouse = null
      }
    }
  }
}
</script>

<style lang="scss">
  #wh-entry-monitor {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 10000;
    overflow: auto;
    line-height: 1.3;
    .card-body {
      padding: 10px 15px;
    }
  }
</style>
